import { render, staticRenderFns } from "./rightSidebarSectionTemplate.vue?vue&type=template&id=b3af269e"
import script from "./rightSidebarSectionTemplate.vue?vue&type=script&lang=js"
export * from "./rightSidebarSectionTemplate.vue?vue&type=script&lang=js"
import style0 from "./rightSidebarSectionTemplate.vue?vue&type=style&index=0&id=b3af269e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports